import { render, staticRenderFns } from "./CmgFullScreen.vue?vue&type=template&id=53a42a67&scoped=true&lang=pug&"
import script from "./cmg-full-screen.ts?vue&type=script&lang=ts&"
export * from "./cmg-full-screen.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a42a67",
  null
  
)

export default component.exports